// Centralised content for Studio Cecconato Michele
// All texts in Italian, sourced from client document. No SEO data.

export const studio = {
  name: "Studio Tecnico Cecconato",
  ownerTitle: "Geom. Michele Cecconato",
  shortName: "Cecconato Geometra",
  address: "Via Morganella 4/c, 31020 Villorba (TV)",
  city: "Villorba (TV)",
  province: "Treviso",
  phone: "0422 920284",
  phoneHref: "tel:+390422920284",
  email: "info@cecconato.it",
  emailHref: "mailto:info@cecconato.it",
  albo: "Albo Geometri Provincia di Treviso n. 2306",
  founded: 1990,
  experienceYears: "30+",
};

export const heroPhotos = [
  "/images/home/1.jpg",
  "/images/home/2.jpg",
  "/images/home/3.jpg",
  "/images/home/4.jpg",
  "/images/home/5.jpg",
  "/images/home/6.jpg",
];

export const officePhotos = [
  "/images/home/7-Ingresso ufficio.jpg",
  "/images/home/8-Ingresso ufficio.jpg",
  "/images/home/9-Interno ufficio.JPG",
  "/images/home/10-Interno ufficio.JPG",
  "/images/home/11-Interno ufficio.JPG",
];

export const services = [
  {
    slug: "progettazione",
    title: "Progettazione e Pratiche Amministrative",
    short:
      "Edilizia residenziale, commerciale e produttiva. Direzione lavori, contabilità, urbanistica.",
    icon: "DraftingCompass",
    body: [
      {
        h: "Edilizia",
        p: `La progettazione edile è finalizzata al raggiungimento di un modello architettonico che soddisfi a pieno i desideri del cliente, inserendosi in modo armonioso nel territorio e rispettando il budget di spesa prefissato. Lo studio segue le varie fasi della progettazione – preliminare, definitiva ed esecutiva – raccogliendo ed elaborando le richieste e le preferenze del cliente, valutando i vincoli e le norme vigenti e la funzionalità degli ambienti. Vengono impiegate le innovative tecniche di progettazione 3D e BIM, fino alla produzione, su richiesta, di viste fotorealistiche.\n\nParticolare cura ed impegno vengono profusi nella gestione del cantiere: Direzione lavori, contabilità, pratiche amministrative fino al completamento dell'opera. Lo studio si avvale di una rete di professionisti specializzati in ingegneria, impiantistica e in tutte le altre discipline necessarie a fornire un servizio completo in ambito antisismico, certificazioni energetiche, progettazione termoidraulica ed elettrica.`,
      },
      {
        h: "Infrastrutture e urbanizzazione",
        p: `Accanto all'edilizia si segue, in collaborazione con altre figure professionali, anche la progettazione urbanistica e stradale: Piani di Lottizzazione e di Recupero, Lottizzazioni, opere stradali ed infrastrutturali in genere con i relativi manufatti e reti di servizi.`,
      },
    ],
    bullets: [
      "Progettazione preliminare / definitiva / esecutiva di fabbricati residenziali, commerciali e produttivi",
      "Progettazione opere di urbanizzazione e sottoservizi",
      "Direzione lavori",
      "Preventivazione e contabilità lavori",
      "Ristrutturazione, restauro, ampliamento e riqualificazione energetica",
    ],
  },
  {
    slug: "topografia-geomatica",
    title: "Topografia e Geomatica",
    short:
      "Rilievi topografici plano-altimetrici, monitoraggi, riconfinamenti, modellazione 3D.",
    icon: "Compass",
    body: [
      {
        h: "Topografia",
        p: `Dal greco tópos (luogo) e gráphein (scrivere): la scienza che studia gli strumenti ed i metodi di calcolo e disegno necessari ad ottenere una rappresentazione grafica particolareggiata della superficie terrestre.`,
      },
      {
        h: "Geomatica",
        p: `Evoluzione della topografia, si occupa della gestione automatizzata dell'informazione relativa al territorio. Rappresenta uno dei punti di forza dello studio, raggiunto grazie a continui investimenti in risorse e ricerca. Lo studio dispone delle più innovative strumentazioni — Stazione totale, GPS, Laser Scanner, Drone — sia per il rilievo che per l'elaborazione dei dati. La competenza, l'esperienza maturata negli anni e la qualità della strumentazione disponibile rappresentano garanzia di efficienza e di affidabilità nei confronti del cliente.`,
      },
    ],
    bullets: [
      "Rilevamenti topografici plano/altimetrici di piccoli e grandi territori, urbani ed extraurbani",
      "Rilievi architettonici di edifici e manufatti (consistenza, struttura, conservazione, fessurazioni)",
      "Triangolazioni e poligonali di precisione",
      "Monitoraggio di cedimenti e spostamenti",
      "Rilievi e tracciamenti per urbanizzazioni, lottizzazioni e lavori esecutivi (strade, ferrovie, infrastrutture)",
      "Riconfinamenti",
      "Rilievi cave, discariche ed attività estrattive con calcoli movimenti terra",
      "Rilevazioni GNSS multifrequenza (statici, statici rapidi, PPK, RTK)",
      "Rilievi fotogrammetrici e LIDAR con drone",
      "Rilievi laser scanner",
      "Modellazione 3D con generazione di modelli fotorealistici",
    ],
  },
  {
    slug: "cartografia-gis",
    title: "Cartografia e G.I.S.",
    short:
      "Carte tematiche, georeferenziazione e sistemi informativi territoriali.",
    icon: "Map",
    body: [
      {
        h: "Cartografia",
        p: `Realizzazione di carte topografiche nelle quali riportare, su una superficie piana di riferimento, tutti i punti che caratterizzano la superficie convessa terrestre. Il passaggio dalla superficie convessa al piano della carta richiede opportune transazioni geometriche per minimizzare le inevitabili deformazioni.`,
      },
      {
        h: "G.I.S.",
        p: `Geographical Information System o sistema informativo territoriale (S.I.T.): strumento che permette di analizzare, rappresentare ed interrogare entità o eventi che si verificano sul territorio. La tecnologia GIS integra le più comuni operazioni legate all'uso di database (interrogazioni e analisi statistiche) con l'analisi geografica consentita dalle cartografie numeriche, raster e vettoriali.\n\nLo studio, associando le più innovative tecniche di rilievo alla raccolta e catalogazione delle informazioni del territorio, è in grado di produrre svariate tipologie di cartografie e carte tematiche.`,
      },
    ],
    bullets: [
      "Cartografie e rilievi in larga scala",
      "Georeferenziazione rilievi su cartografie Gauss e UTM",
      "Carte tematiche",
      "Restituzione rilievi reti sottoservizi con relativi dati informativi",
    ],
  },
  {
    slug: "drone",
    title: "Rilievi con Drone",
    short:
      "Fotogrammetria 3D, LIDAR, termografia e multispettrale per agricoltura di precisione.",
    icon: "Plane",
    body: [
      {
        h: "Fotogrammetria e LIDAR aerei",
        p: `I rilievi fotogrammetrici tridimensionali stanno rivoluzionando il mondo della topografia. Effettuati con UAS (Unmanned Aircraft System) — in italiano SAPR, sistemi aeromobili a pilotaggio remoto — sono l'evoluzione delle tecniche di fotogrammetria aerea o terrestre conosciute fin dai primi decenni del XX secolo.\n\nL'attuale tecnica di fotogrammetria 3D consiste nell'acquisizione di immagini digitali ad alta definizione opportunamente sovrapposte, dalle quali — mediante software dedicati — si originano nuvole di punti 3D in cui ogni pixel diviene entità vettoriale tridimensionale con relativo colore RGB.\n\nUn'importante evoluzione è data dall'utilizzo di sensori LIDAR a bordo di droni: rilievi tridimensionali dall'alto di ampie porzioni di territorio in breve tempo ed a costi contenuti, garantendo completezza e precisione.`,
      },
      {
        h: "Sensori avanzati",
        p: `Oltre ai rilievi 3D, utilizzando appositi sensori, è possibile ottenere rilievi termografici per il monitoraggio delle dispersioni termiche di edifici, manufatti e campi fotovoltaici, e rilievi con camere multispettrali per la verifica dello stato vegetativo delle colture in campo aperto (agricoltura di precisione).`,
      },
    ],
    bullets: [
      "Ortofoto georeferenziate",
      "Restituzione 3D mediante nuvola di punti georeferenziata",
      "Restituzione DSM (Modello digitale della superficie) e DTM (Modello digitale del terreno)",
      "Generazione mesh 3D",
      "Post elaborazione secondo le procedure topografiche",
      "Rilievi termografici di edifici, pannelli fotovoltaici, infrastrutture",
      "Rilievi con camera multispettrale per agricoltura di precisione",
    ],
  },
  {
    slug: "laser-scanner",
    title: "Laser Scanner 3D",
    short:
      "Scansioni statiche e dinamiche per rilievi architettonici, infrastrutturali e giudiziari.",
    icon: "ScanLine",
    body: [
      {
        h: "Tecnologia",
        p: `Il Laser Scanner 3D rappresenta la nuova frontiera per svariati ambiti applicativi: architettonico (edifici, manufatti, monumenti), infrastrutturale (ponti, viadotti), impiantistico, territoriale (cave, discariche, movimenti franosi), giudiziario (rilievo scene del crimine, incidenti).\n\nA differenza di altre tecniche, il laser scanner 3D non ha carattere soggettivo: non vengono scelti soltanto alcuni punti caratteristici, ma viene rilevato tutto ciò che è presente nel range d'azione dell'impulso. L'elevata quantità di dati acquisiti in brevissimo tempo consente di eseguire il rilievo geometrico degli oggetti con un ragguardevole livello di dettaglio e completezza.\n\nIl risultato della scansione è una nuvola di punti 3D che, opportunamente elaborata, permette di generare il modello tridimensionale dell'oggetto rilevato.`,
      },
    ],
    bullets: [
      "Rilievi 3D esterni ed interni di fabbricati e manufatti",
      "Rilievi 3D in ambito territoriale: cave, discariche, movimenti franosi",
      "Rilievi 3D in ambito giudiziario",
      "Generazione di nuvole di punti 3D",
      "Post elaborazione con restituzione modelli CAD 2D, 3D e modellazione solida",
    ],
  },
  {
    slug: "catasto",
    title: "Pratiche Catastali",
    short:
      "Frazionamenti, accatastamenti, volture e consultazioni presso l'Agenzia delle Entrate.",
    icon: "FileText",
    body: [
      {
        h: "Aggiornamenti catastali",
        p: `Il Catasto — ora Agenzia delle Entrate, Ufficio del Territorio — non è un archivio fisso ed immodificabile, ma è in continuo aggiornamento ogni qualvolta vi sia una modifica del patrimonio immobiliare (terreni o fabbricati), sia relativamente alla consistenza che alla titolarità. Lo studio è in grado di assistere il cliente nell'adempimento di tutti gli atti di aggiornamento della banca dati catastale, operando con adeguata strumentazione topografica e specifici software, interfacciandosi in tempo reale, attraverso i portali telematici, con l'Agenzia del Territorio.`,
      },
    ],
    bullets: [
      "Atti aggiornamenti Catasto Terreni: Frazionamenti, Tipi Mappale, Variazioni di coltura",
      "Atti aggiornamento Catasto Fabbricati",
      "Denunce di nuovo accatastamento e variazioni catastali",
      "Volture catastali",
      "Consultazione banca dati e cartografie catastali",
      "Riconfinamenti",
    ],
  },
  {
    slug: "certificazione-energetica",
    title: "Diagnosi e Certificazioni Energetiche",
    short: "APE, audit energetici e progettazione di interventi di riqualificazione.",
    icon: "Leaf",
    body: [
      {
        h: "Diagnosi energetica",
        p: `Per diagnosi energetica si intendono tutte le indagini effettuate su un immobile per valutare dove e come l'energia viene consumata: si valutano con precisione "la quantità e la qualità dell'energia utilizzata per riscaldamento, raffrescamento, illuminazione ed utilizzo di elettrodomestici". La diagnosi rappresenta la prima fase di una riqualificazione energetica: senza una conoscenza attenta delle caratteristiche del fabbricato non è possibile proporre soluzioni efficaci di miglioramento.\n\nÈ molto importante la competenza del tecnico che effettua la diagnosi, dal momento che da lui dipendono il progetto di riqualificazione e la valutazione del più probabile ritorno economico degli interventi. In una valutazione energetica completa andrebbero considerati anche il degrado della struttura, lo stato di manutenzione degli impianti e la documentazione amministrativa: l'insieme di queste indagini viene chiamato "Due diligence immobiliare".`,
      },
    ],
    bullets: [
      "Reperimento dati dell'immobile (catastali, urbanistici)",
      "Sopralluogo ed analisi involucro edilizio ed impianti",
      "Valutazione e diagnosi energetica con redazione dell'APE",
      "Individuazione e quantificazione economica degli interventi di riqualificazione",
    ],
  },
  {
    slug: "consulenze",
    title: "Consulenze e Gestione Immobiliare",
    short:
      "Compravendite, successioni, perizie di stima e valutazioni immobiliari.",
    icon: "Briefcase",
    body: [
      {
        h: "Assistenza tecnica",
        p: `La consulenza tecnica di parte assiste il cliente in vari ambiti: conoscenza del mercato per valutare prezzi, costi ed andamento; assistenza nella stipulazione di contratti di compravendita e permuta; dichiarazioni di successione e relative documentazioni; studi di fattibilità e perizie di stima; valutazioni immobiliari per l'ottenimento di mutui fondiari o per altri motivi economici.`,
      },
    ],
    bullets: [
      "Conoscenza del mercato: prezzi, costi e andamento",
      "Assistenza in compravendite e permute",
      "Dichiarazioni di successione",
      "Studi di fattibilità e perizie di stima",
      "Valutazioni immobiliari per mutui fondiari",
    ],
  },
];

export const equipment = [
  {
    category: "Stazione totale",
    description:
      "Stazione totale motorizzata ad alta precisione, indispensabile per triangolazioni, monitoraggi e tracciamenti.",
    items: [
      {
        name: "Leica TCRP 1201",
        photos: [
          "/images/strumentazione/stazione/Leica TCRP 1201_1.jpg",
          "/images/strumentazione/stazione/Leica TCRP 1201_2.jpg",
          "/images/strumentazione/stazione/Leica TCRP 1201_3.jpg",
        ],
      },
    ],
  },
  {
    category: "Ricevitori satellitari GNSS",
    description:
      "Ricevitori GNSS RTK multifrequenza per rilievi statici, statici rapidi, cinematici post-processati (PPK) e in tempo reale (RTK).",
    items: [
      {
        name: "Geomax Zenit 25 Pro",
        sub: "GNSS RTK multifrequenza doppia costellazione",
        photos: [
          "/images/strumentazione/gnss/Zenit_25pro_1.jpg",
          "/images/strumentazione/gnss/Zenit_25pro_2.jpg",
        ],
      },
      {
        name: "Geomax Zenit 60",
        sub: "GNSS RTK multifrequenza multi-costellazione",
        photos: [
          "/images/strumentazione/gnss/Zenith60_1.jpg",
          "/images/strumentazione/gnss/Zenith60_2.jpg",
          "/images/strumentazione/gnss/Zenith60_3.jpg",
        ],
      },
    ],
  },
  {
    category: "Droni SAPR",
    description:
      "Sistemi aeromobili a pilotaggio remoto per fotogrammetria, LIDAR, termografia e camere multispettrali.",
    items: [
      {
        name: "DJI Mini 3 Pro",
        sub: "Drone compatto per ispezioni e rilievi rapidi",
        photos: [
          "/images/strumentazione/droni/DJI MINI 3PRO_1.jpg",
          "/images/strumentazione/droni/DJI MINI 3PRO_2.jpg",
          "/images/strumentazione/droni/DJI MINI 3PRO_3.jpg",
        ],
      },
      {
        name: "DJI Mavic 3 Enterprise Multispettrale",
        sub: "Camera multispettrale per agricoltura di precisione",
        photos: [
          "/images/strumentazione/droni/DJI MAVIC 3M_1.jpg",
          "/images/strumentazione/droni/DJI MAVIC 3M_2.jpg",
          "/images/strumentazione/droni/DJI MAVIC 3M_3.jpg",
        ],
      },
      {
        name: "DJI Matrice 350 RTK + Zenmuse L2",
        sub: "Piattaforma professionale con sensore LIDAR Zenmuse L2",
        photos: [
          "/images/strumentazione/droni/DJI MATRICE 350_1.jpg",
          "/images/strumentazione/droni/DJI MATRICE 350_2.jpg",
          "/images/strumentazione/droni/DJI MATRICE 350_3.jpg",
        ],
      },
    ],
  },
  {
    category: "Laser Scanner e SLAM",
    description:
      "Sistemi di scansione laser statici e dinamici per rilievi 3D ad altissima densità.",
    items: [
      {
        name: "Riegl VZ-400i",
        sub: "Laser scanner 3D statico ad alta precisione",
        photos: [
          "/images/strumentazione/laserscanner/RIEGL VZ400i_1.jpg",
          "/images/strumentazione/laserscanner/RIEGL VZ400i_2.jpg",
          "/images/strumentazione/laserscanner/RIEGL VZ400i_3.jpg",
        ],
      },
      {
        name: "Lixel L2 Pro",
        sub: "Sistema SLAM mobile per scansioni dinamiche",
        photos: [
          "/images/strumentazione/laserscanner/Lixel-L2-Pro_1.jpg",
          "/images/strumentazione/laserscanner/Lixel-L2-Pro_2.jpg",
        ],
      },
    ],
  },
];
